import { socialLinks } from "./social.config";

export const FooterData = {
  // Main CTA heading
  heading: "Ready to build something amazing?",

  // CTA button
  button: {
    text: "Schedule a Call",
    link: "/contact",
  },

  // Social links
  socialLinks, // imported from social.config.js

  // Copyright, year is dynamic
  copyright: "Amara Lune. All rights reserved.",
};
